<!-- Home Section -->
<section id="home" class="container-fluid home-Section">

  <div class="container content-main text-center">
    <h2 class="main-text">Web & Mobile Software Application Development Services</h2>
    <!--    <h2 class="main-text">Fighting Covid-19: We are at the forefront</h2>-->
    <!--    <p class="text-center text-white" style=""><a style="text-decoration: none;color: white" routerLink="/insights/fighting-covid-19-we-are-at-the-forefront">Find out more...</a></p>-->
  </div>

</section>


<!--Contact Us-->
<section id="contactUs" class="contact-section">
  <div class="container">
    <h2><b>Contact Us</b></h2>

    <div class="row mt-5" style="margin-top: 24px!important;">

      <div class="col-12 col-sm-12 col-md-6 contact-text">
        <!--        <p>We are committed to providing an excellent experience for all of our clients and those interested in products-->
        <!--          & services. It's easy to get in touch with us by email or submitting the form.</p>-->
        <p style="margin-bottom: 5px">IrvineTek is agile consulting and tech management firm. We specialize in wide range of software
          development services including discovery, wireframing, design, development, implementation, setup & maintenance.</p>
        <p style="margin-bottom: 5px">Our software development services are affordable. Regardless of the size of the project,
          our team carries out in-depth analysis of your business objectives before proposing solutions that best fit your needs.</p>
        <p class="mb-2"><b>Contact us for 100% free no obligation consultation.</b></p>
        <p class="m-0">IrvineTek</p>
<!--        <p>30211 Avenida de Las Bandera, Ste 200 <br> Rancho Santa Margarita, CA-92688</p>-->
        <p>info@irvinetek.com | <a style="color: black;text-decoration: none" href="https://irvinetek.com/" target="_blank">www.irvinetek.com</a></p>
      </div>

      <div class="col-12 col-sm-12 col-md-6 contact-form">

        <form>
          <div class="row">
            <div class="col-12 col-sm-12 col-md-6">
              <input type="text" placeholder="Name*" name="name" [(ngModel)]="name">
            </div>
            <div class="col-12 col-sm-12 col-md-6 left-padding-input">
              <input type="text" placeholder="Email*" name="email" [(ngModel)]="email">
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-12 col-md-6">
              <input type="text" placeholder="Phone" name="phone" [(ngModel)]="phone" (keyup)="onlyNumeric($event)">
            </div>
            <div class="col-12 col-sm-12 col-md-6 left-padding-input">
              <!--              <input type="text" placeholder="Website">-->
              <select [(ngModel)]="topic" name="topic">
                <option value="" disabled>Subject*</option>
                <option value="Free consulting session">Free consulting session</option>
                <option value="Web Development">Web Developement</option>
                <option value="Mobile App Development">Mobile App Developement</option>
                <option value="Quality Assurance">Quality Assurance</option>
                <option value="Team Augmentation">Team Augmentation</option>
                <option value="Others">Others</option>
              </select>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <textarea rows="5" class="textarea" placeholder="Message*" name="message" [(ngModel)]="message"></textarea>
            </div>
          </div>

          <button (click)="onSubmit()" [disabled]="showLoder" class="btn btn-primary" style="background-color: #003c77;border-color: #033057">Send Message
            <img src="../../assets/images/loader.gif" style="width: 20px" *ngIf="showLoder === true">
          </button>

        </form>

      </div>
    </div>

  </div>
</section>
